import { useCallback, useEffect, useState } from "react";
import { Button, Input, Table } from "antd";
import { Note, Page } from "../../../helbest";
import { ReactComponent as SearchIcon } from "../../../assets/svg/search.svg";
import { useTranslation } from "react-i18next";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import { API } from "../../../request/api";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import AccessDeniedError from "../../components/ErrorComponents/AccessDeniedError";

const Stocks = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [page, setPage] = useState({
    page: 1,
    pages: 1,
    hasNext: false,
    hasPrevious: false,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("q") || "";

  useEffect(() => {
    setLoading(true);

    API.get
      .getStocks(page.page, search)
      .then((response) => {
        if (response.code === 200) {
          setData(response.data);
          setPage({
            page: response.pagination.page,
            pages: response.pagination.pages,
            hasNext: !!response.pagination.next_url,
            hasPrevious: !!response.pagination.previous_url,
          });
        } else if (response.code === 403) {
          setError(true);
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);

    API.get
      .getStocks(1, search)
      .then((response) => {
        if (response.code === 200) {
          setLoading(false);
          setData(response.data);
          setPage({
            page: response.pagination.page,
            pages: response.pagination.pages,
            hasNext: !!response.pagination.next_url,
            hasPrevious: !!response.pagination.previous_url,
          });
        } else if (response.code === 403) {
          setError(true);
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [search]);

  const ChangePage = (type) => {
    setLoading(true);

    API.get
      .getStocks(type === "next" ? page.page + 1 : page.page - 1, search)
      .then((response) => {
        if (response.code === 200) {
          setData(response.data);
          setPage({
            page: response.pagination.page,
            pages: response.pagination.pages,
            hasNext: !!response.pagination.next_url,
            hasPrevious: !!response.pagination.previous_url,
          });
        } else if (response.code === 403) {
          setError(true);
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: t("stocks.name"),
      dataIndex: "product__name",
      fixed: "left",
      width: 160,
      className: "stocks-first-column",
    },
    {
      title: t("stocks.total"),
      dataIndex: "delivered",
      width: 80,
      align: "center",
    },
    {
      title: t("stocks.my_share"),
      dataIndex: "sc_share",
      width: 80,
      align: "center",
    },
    {
      title: t("stocks.hig_share"),
      dataIndex: "hig_share",
      width: 80,
      align: "center",
    },
    {
      title: t("stocks.used"),
      dataIndex: "services",
      width: 80,
      align: "center",
    },
    {
      title: t("stocks.remaining"),
      dataIndex: "remain_stock",
      width: 80,
      align: "center",
    },
  ];

  const debouncedSearchFn = useCallback(
    _.debounce((value) => {
      setSearchParams(
        (prevState) => {
          prevState.set("q", value);
          return prevState;
        },
        { replace: true }
      );
    }, 500),
    []
  );

  return (
    <Page
      customHeader={<HeaderBack url={"/"} title={t("stocks.title")} />}
      headerFix
      showFooter={false}
    >
      {error ? (
        <AccessDeniedError />
      ) : (
        <>
          <Input
            defaultValue={search}
            variant="borderless"
            className="stocksSearchInput mt-5"
            prefix={<SearchIcon className="stocksSearchIcon" />}
            placeholder={t("common.search")}
            onChange={(e) => {
              debouncedSearchFn(e.target.value);
            }}
          />
          <div direction="ltr">
            {data || loading ? (
              <Table
                direction="ltr"
                bordered={false}
                loading={loading}
                size="small"
                expandable={false}
                rowSelection={false}
                columns={columns}
                pagination={false}
                dataSource={data}
                scroll={{ x: "max-content" }}
                className="mt-5 stocks-table-container"
                ellipsis={true}
                rowHoverable={false}
              />
            ) : (
              <span className="stocks-empty">{t("stocks.empty")}</span>
            )}
          </div>
          {page.hasNext || page.hasPrevious ? (
            <div className="stocks-buttons">
              <Button
                type="primary"
                ghost
                size="middle"
                icon={<LeftOutlined />}
                disabled={!page.hasPrevious || loading}
                onClick={() => ChangePage("prev")}
              >
                {t("common.prev")}
              </Button>
              <span>
                {page.page}/{page.pages}
              </span>
              <Button
                type="primary"
                ghost
                size="middle"
                icon={<RightOutlined />}
                iconPosition="end"
                disabled={!page.hasNext || loading}
                onClick={() => ChangePage("next")}
              >
                {t("common.next")}
              </Button>
            </div>
          ) : null}
        </>
      )}
    </Page>
  );
};
export default Stocks;
